import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export const BoldText = (props: PropsWithChildren) => {
  return (
    <Typography
      component="span"
      sx={{
        fontWeight: 500,
        color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
      }}
    >
      {props.children}
    </Typography>
  );
};
